"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resources = void 0;
const ASSOCIATIONS = 'associations';
const LEAGUES = 'leagues';
const SEASONS = 'seasons';
const SEASON_ROSTERS = 'season_rosters';
const DIVISIONS = 'divisions';
const TEAMS = 'teams';
const TEAM_ROSTERS = 'team_rosters';
const PLAYERS = 'players';
const COACHES = 'coaches';
const REFEREES = 'referees';
const COMPLETED_GAMES = 'completed_games';
const SCHEDULED_GAMES = 'scheduled_games';
const GAME_REFEREE_REPORTS = 'game_referee_report';
const GAME_NOTES = 'game_notes';
const REPORTS = 'reports';
const INVITATIONS = 'invitations';
const USERS = 'users';
const API_KEYS = 'api_keys';
const FILES = 'files';
const LOCATIONS = 'locations';
const CLUBS = 'clubs';
const PROTOTEAMS = 'prototeams';
const Resources = {
    ASSOCIATIONS,
    LEAGUES,
    SEASONS,
    SEASON_ROSTERS,
    DIVISIONS,
    TEAMS,
    TEAM_ROSTERS,
    PLAYERS,
    COACHES,
    REFEREES,
    COMPLETED_GAMES,
    SCHEDULED_GAMES,
    GAME_REFEREE_REPORTS,
    GAME_NOTES,
    REPORTS,
    INVITATIONS,
    USERS,
    API_KEYS,
    FILES,
    LOCATIONS,
    CLUBS,
    PROTOTEAMS,
};
exports.Resources = Resources;
